<template>
  <b-server-table
    :key="tableRenderKey"
    :filter-props="{
      filterMap: [
        { key: 'search' },
        {
          key: 'typeId',
          directory: 'auditTypes',
          component: 'select',
        },
        {
          key: 'statusId',
          directory: 'auditStatuses',
          component: 'select',
        },
        {
          key: 'startScheduledCheckDate',
          component: 'input-date',
        },
        {
          key: 'endScheduledCheckDate',
          component: 'input-date',
        },
        {
          key: 'year',
          component: 'input',
          placeholder: 'yyyy',
          mask: '20##',
        },
      ],
    }"
    :headers="auditListHeaders"
    :request-func="auditList"
    @click:row="
      $router.push({
        name: 'audit-single',
        params: { id: $event.id },
      })
    ">
    <template #action-button>
      <div class="d-flex align-center gap-3">
        <ExportPfForm
          :url="auditRecommendationExport"
          button-text="Реєстр рекомендацій"
          exportFileName="Реєстр рекомендацій" />
        <v-btn v-if="can('audits.create')" @click.stop="createAudit">
          <v-icon class="mr-1">mdi-plus</v-icon>
          Створити аудит
        </v-btn>
      </div>
    </template>
    <template #item.status="{ item }">
      <v-chip
        :style="getColorByStatus(item.statusId)"
        border
        class="font-weight-bold"
        density="comfortable"
        rounded="lg"
        size="small"
        variant="flat"
        style="width: max-content">
        <template #default>
          <span class="font-weight-bold">
            {{ item?.status?.name }}
          </span>
        </template>
      </v-chip>
    </template>
    <template #item.author="{ item }">
      <span>{{ getPersonName(item.author, { initials: true }) }}</span>
    </template>
    <template #item.actions="{ item }">
      <b-action-menu
        :actions="[
          {
            title: 'Переглянути',
            to: { name: 'audit-single', params: { id: item.id } },
            icon: 'mdi-eye',
            iconProps: {
              color: 'blue-darken-3',
            },
          },
          {
            title: 'Редагувати',
            action: () => updateAudit(item),
            icon: 'mdi-pencil',
            iconProps: {
              color: 'blue-darken-3',
            },
            disabled: item.statusId === 3,
          },
        ]"
        icon="mdi-dots-horizontal"></b-action-menu>
    </template>
  </b-server-table>
</template>

<script lang="ts">
import { BActionMenu, BServerTable } from 'best-modules/components'
import { auditListHeaders } from '@/utils/tableHeaders'
import { openDialog } from '@/dialog'
import { useRouter } from 'vue-router'
import { Audit } from '@/utils/types/audit'
import { CustomDate } from 'best-modules/utils'
import { ref } from 'vue'
import ExportPfForm from '@/components/ExportPfForm.vue'
import { useCan } from '@/composables/useCan'
import { getColorByStatus } from '../helpers'
import { getPersonName } from 'best-modules/utils/helpers'
import { auditList, auditRecommendationExport } from '@/requests/audit'

export default {
  name: 'AuditList',
  components: {
    ExportPfForm,
    BServerTable,
    BActionMenu,
  },
  data: () => {
    return {
      auditListHeaders,
    }
  },
  methods: {
    auditRecommendationExport,
    auditList,
    getPersonName,
    CustomDate,
    getColorByStatus,
  },
  setup() {
    const router = useRouter()
    const { can } = useCan()
    const tableRenderKey = ref<number>(1)

    const createAudit = () => {
      openDialog({
        name: 'Audit',
        action: 'create',
        params: {
          cb: audit => {
            router.push({ name: 'audit-single', params: { id: audit.id } })
          },
        },
      })
    }
    const updateAudit = (audit: Audit) => {
      can('audits.update', () => {
        openDialog({
          name: 'Audit',
          action: 'update',
          dialogData: {
            audit,
            plan: audit.plan,
          },
          params: {
            cb: () => (tableRenderKey.value += 1),
          },
        })
      })
    }

    return {
      createAudit,
      updateAudit,
      tableRenderKey,
      can,
    }
  },
}
</script>

<style lang="scss" scoped></style>
